import TransferInterceptModal from './components/transfer-intercept-modal/index.vue';
import type { IOrder } from '~/api/interface/order';
import { useEmptyModal } from '~/hooks/useModal/modals/empty';

export const useTransferIntercept = (options: {
  order: IOrder;
  headers?: Record<string, string>;
  onCancel?: () => void;
}) => {
  const model = useEmptyModal({
    width: 420,
    content: (
      <TransferInterceptModal
        headers={options.headers}
        order={options.order}
        onCancel={() => {
          options.onCancel?.();
          model.destroy();
        }}
      />
    ),
  });
};
